var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { File } from './File';
var FileViewer = /** @class */ (function (_super) {
    __extends(FileViewer, _super);
    function FileViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FileViewer.prototype, "isImg", {
        get: function () {
            var normalizedFilename = this.file.uri.toLowerCase();
            return normalizedFilename.endsWith('.jpg')
                || normalizedFilename.endsWith('.jpeg')
                || normalizedFilename.endsWith('.png')
                || normalizedFilename.endsWith('.ico');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileViewer.prototype, "link", {
        get: function () {
            if (this.isImg) {
                return this.file.uri;
            }
            if (this.file.uri.toLowerCase().endsWith('.pdf')) {
                return this.file.uri;
            }
            return "https://view.officeapps.live.com/op/view.aspx?src=" + this.file.uri;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof File !== "undefined" && File) === "function" ? _a : Object)
    ], FileViewer.prototype, "file", void 0);
    FileViewer = __decorate([
        Component
    ], FileViewer);
    return FileViewer;
}(Vue));
export default FileViewer;
